import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";

function ProgressBar({ currentStep, totalSteps, labels }) {
  const progressWidth = useMemo(
    () => `${(currentStep / totalSteps) * 100}%`,
    [currentStep, totalSteps]
  );

  return (
    <div className="mb-8">
      <div className="h-2 bg-gray-700 rounded-full">
        <motion.div
          className="h-2 bg-blue-600 rounded-full"
          initial={{ width: 0 }}
          animate={{ width: progressWidth }}
          transition={{ duration: 0.3 }}
        />
      </div>
      <div className="flex justify-between mt-2 text-sm text-gray-400">
        {labels.map((stepText, idx) => (
          <span key={idx} className="flex-1 text-center">
            {stepText}
          </span>
        ))}
      </div>
    </div>
  );
}

ProgressBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default React.memo(ProgressBar);
